<template>
    <div class="cz2__customizer">
        <transition name="cz2__fade">
            <splash v-if="splashShown" />
        </transition>
        <transition name="cz2__fade">
            <steps />
        </transition>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__customizer {
            position: absolute;

            left: 0;
            top: 0;
            width: 100%;
            height: 100%;

            @include respond-above(sm) {
                display: block;
            }
        }
    }
</style>

<script>
    import Splash from './Splash.vue';
    import Steps from './Steps.vue';

    export default {
        components: {
            Steps,
            Splash,
        },

        computed: {
            selectedStep() {
                return this.$store.state.selectedStep;
            },

            splashShown() {
                return this.selectedStep === 'splash' || this.selectedStep === 'splashSelector';
            },
        },

        watch: {
            selectedStep() {
                if (this.selectedStep == null) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Got empty step, resetting to splash',
                    });

                    // Enforce splash screen as the default state.
                    this.$store.dispatch('selectStep', 'splash');
                }
            },
        },
    };
</script>
